import * as yup from "yup"
import { FormComponent, FormComponentType } from "@components/FormBuilder/types"
import { GenericForm } from "@custom-types/form"

export const getUserFormFields = (options: FormComponent["options"]): GenericForm => ({
  first_name: {
    title: "Name",
    editable: true,
    type: FormComponentType.Input,
  },
  last_name: {
    title: "Surname",
    editable: true,
    type: FormComponentType.Input,
  },
  organisation_key: {
    title: "Organisation",
    editable: true,
    type: FormComponentType.Dropdown,
    options,
    validateFieldsOnChange: ["key"],
  },
  key: {
    title: "Email",
    editable: true,
    type: FormComponentType.Input,
  },
  active: {
    title: "Active",
    editable: true,
    type: FormComponentType.Checkbox,
  },
})

export const usersFormSchema = (domains: string[]) =>
  yup.object().shape({
    first_name: yup.string().required("Name is required"),
    last_name: yup.string().required("Surname is required"),
    organisation_key: yup.string().required("Organisation is required"),
    key: yup
      .string()
      .email("Incorrect email format")
      .required("Email is required")
      .when("organisation_key", {
        is: (value: string | undefined) => value,
        then: (schema) =>
          schema.test({
            name: "organisation-allowed-email",
            message: `Allowed domains by selected Organisation: ${domains.join(", ")}`,
            test: (value) => {
              if (value === undefined) {
                return false
              }

              const valueDomain = value.toLowerCase().split("@")[1]
              if (valueDomain === undefined) {
                return false
              }

              return domains.includes(valueDomain)
            },
          }),
        otherwise: (schema) =>
          schema.test({
            name: "organisation-missing",
            message: "Please fill in Organisation field",
            test: () => false,
          }),
      }),
    active: yup.boolean().required("Active is required"),
  })
